import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { YOUR_ASSORTMENT_EXTERNAL } from '~shared/constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { OrderHistoryApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { GaTrackingEventAction, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-header-your-assortment',
  templateUrl: './header-your-assortment.component.html',
  styleUrls: ['./header-your-assortment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderYourAssortmentComponent implements OnInit, OnDestroy {
  @Output() onClick = new EventEmitter<boolean>();
  isMobile: boolean;
  public readonly assortmentLink = YOUR_ASSORTMENT_EXTERNAL();
  private unsubscribe$ = new Subject<void>();

  constructor(
    private mediaObserver: MediaObserver,
    private applicationEventService: ApplicationEventService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initMediaObserver();
  }

  hideMenuAndSendGAYourAssortmentEvent(): void {
    this.sendGAEventYourAssortment();
    this.onClick.emit(true);
  }

  private sendGAEventYourAssortment(): void {
    this.applicationEventService.publish(
      new OrderHistoryApplicationEvent({
        event: GaTrackingEventName.YourAssortmentHeaderInteraction,
        action: GaTrackingEventAction.YourAssortmentHeader,
        label: null,
      })
    );
  }

  private initMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.cd.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
